
export function saveToken(token: string) {
    window.localStorage.setItem("token", token);
}
